import { createStore } from 'jotai';

export const confirmationStore = createStore();
